export const SEND_A_FORM_CLOSE = 'SEND_A_FORM_CLOSE';
export const SEND_A_FORM_FIELD_CLICKED = 'SEND_A_FORM_FIELD_CLICKED';
export const SEND_A_FORM_FIELD_CLICKED_HANDLED = 'SEND_A_FORM_FIELD_CLICKED_HANDLED';
export const SEND_A_FORM_INIT = 'SEND_A_FORM_INIT';
export const SEND_A_FORM_PREVIEW_FORM_VIEW = 'SEND_A_FORM_PREVIEW_FORM_VIEW';
export const SEND_A_FORM_PREVIEW_LIST_VIEW = 'SEND_A_FORM_PREVIEW_LIST_VIEW';
export const SEND_A_FORM_SET_SELECTED_FIELDS = 'SEND_A_FORM_SET_SELECTED_FIELDS';
